import { ArpeggiSplit } from '../splits'

export enum SplitStatus {
  PREDICTED = 'predicted',
  DEPLOYING = 'deploying',
  DEPLOYED = 'deployed',
  ERROR = 'error'
}

export interface Split {
  splitAddress: string
  chainId: number
  splitRecipients: ArpeggiSplit[]
  status: SplitStatus
}

export type Address = `0x${string}`
